/**
 * This is the "old" Files page used when folders feature flag is disabled.
 * New projects should use the normal sibling FilesPage -> Files & Folders
 */
import { FunctionComponent, useMemo } from 'react';
import FederatedMFE from 'common/components/FederatedMFE';
import { useSelector } from 'react-redux';
import {
  isProjectArchived,
  isProjectInactive,
} from 'common/helpers/projectStatusesUtils';
import { getProject } from 'features/project/projectSlice';

import { injectReducerAsync } from 'app/reduxStore';

import styles from './LegacyFilesPage.module.scss';

const LegacyFilesPage: FunctionComponent = () => {
  const project = useSelector(getProject);

  const extraProps = useMemo(
    () => ({
      projectInfo: {
        ...project,
        isProjectArchived: isProjectArchived(project?.status),
        isProjectInactive: isProjectInactive(project?.status),
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={styles.wrapper}>
      <div>
        <FederatedMFE
          urlKey="REACT_APP_FILES_MFE_URL"
          scope="remoteFiles"
          reducerModule="./legacyFilesReducers"
          componentModule="./LegacyFilesPage"
          injectionReducerCb={injectReducerAsync}
          suspenseFallbackStyle={styles['suspense-loader-wrapper']}
          props={extraProps}
        />
      </div>
    </div>
  );
};

export default LegacyFilesPage;
